// Página local /nutrologo-em-bauru/ no template das páginas de tratamento.
// Texto de src/content/locais/nutrologo-em-bauru.md, distribuído nos blocos
// sem reescrita.
import { EtapasLocais as CardsIlustrado, CtaLocal as CtaPratico, FaqLocal as Faq, HeroLocal as Hero, PilaresLocais as Pilares } from "@/components/itv/pages/locais";
import { AutoriaComAviso, BotaoWhatsApp, MapaConsultorio, SecaoTexto, Texto } from "@/components/itv/pages/locais";

export const faqNutrologoBauru = [
  {
    pergunta: "Qual a diferença entre nutrólogo e endocrinologista?",
    resposta:
      "Os dois são médicos especialistas e podem tratar obesidade. O nutrólogo cuida das doenças ligadas à nutrição, como deficiências de vitaminas e minerais, perda de massa muscular e excesso de peso. O endocrinologista cuida das glândulas e dos hormônios, como diabetes e doenças da tireoide. A escolha depende da sua queixa principal.",
  },
  {
    pergunta: "É melhor ir ao nutrólogo ou ao nutricionista?",
    resposta:
      "Depende do que você precisa. O nutrólogo é médico: investiga causas, pede exames, faz exame físico e pode prescrever tratamento. O nutricionista tem formação em Nutrição e é o profissional do plano alimentar e da educação alimentar no dia a dia. Quando há suspeita de doença, deficiência ou dificuldade para emagrecer, a avaliação médica costuma ser o primeiro passo.",
  },
  {
    pergunta: "O Dr. Thiago atende por convênio em Bauru?",
    resposta:
      "O atendimento no consultório do Jardim Europa é particular, tanto na consulta presencial quanto na teleconsulta. O valor, as formas de pagamento e os horários são informados no agendamento pelo WhatsApp. Se você tiver dúvida sobre reembolso do seu plano de saúde, a informação deve ser pedida diretamente à operadora.",
  },
  {
    pergunta: "Quanto custa a consulta com o nutrólogo?",
    resposta:
      "O valor é informado no agendamento pelo WhatsApp, junto com as formas de pagamento. A bioimpedância faz parte da consulta e não é cobrada à parte. Os exames laboratoriais, quando pedidos, são feitos no laboratório de sua preferência, e a cobrança deles segue as regras do próprio laboratório ou do seu plano de saúde.",
  },
  {
    pergunta: "O consultório tem estacionamento?",
    resposta:
      "Sim. O Edifício Prime Square, onde fica o consultório, tem garagem com vagas rotativas para visitantes. O prédio fica na Av. Getúlio Vargas, no Jardim Europa, e o mapa com a localização está nesta página. Se precisar de orientação para chegar, peça pelo WhatsApp ao agendar.",
  },
  {
    pergunta: "Não moro em Bauru. Posso me consultar?",
    resposta:
      "Pode. A teleconsulta atende pacientes de todo o Brasil, com avaliação de histórico, sintomas, hábitos e exames, que você faz no laboratório da sua cidade. Quando o caso pede exame físico ou uma avaliação específica, indicamos a consulta presencial em Bauru. Os detalhes estão na página de teleconsulta.",
  },
];

const pilares = [
  {
    icone: "/icones/search.svg",
    titulo: "Queixas mais frequentes",
    texto: "Dificuldade para emagrecer ou manter o peso, efeito sanfona, perda de massa muscular, cansaço e falta de disposição, sono ruim e alterações hormonais.",
  },
  {
    icone: "/icones/clipboard.svg",
    titulo: "Mais de uma causa",
    texto: "Essas queixas costumam ter mais de uma causa, por isso a avaliação inclui alimentação, sono, exercício, composição corporal e exames.",
  },
  {
    icone: "/icones/activity.svg",
    titulo: "Diagnóstico e tratamento",
    texto: "De deficiências como a anemia por falta de ferro até condições crônicas como obesidade, diabetes e hipertensão. O nutrólogo pode pedir exames e avaliar força e capacidade funcional para investigar sarcopenia (perda de massa e força muscular).",
  },
];

const etapas = [
  {
    img: "/img/emagrecimento/conduta-1.webp",
    titulo: "Conversa e histórico",
    texto: "Sintomas, hábitos, objetivos e tentativas anteriores. Avaliamos também alimentação, atividade física, sono, rotina e o que você já usa de suplemento ou medicamento.",
  },
  {
    img: "/img/emagrecimento/conduta-2.webp",
    titulo: "Exame físico",
    texto: "Feito no consultório. É a etapa que a teleconsulta não substitui, e por isso a consulta presencial é indicada quando o caso pede exame físico.",
  },
  {
    img: "/img/emagrecimento/conduta-3.webp",
    titulo: "Bioimpedância na própria consulta",
    texto: "A análise de composição corporal por bioimpedância já está inclusa e mostra gordura, massa muscular e gordura visceral em números. Esses dados entram no plano junto com o restante da avaliação.",
  },
  {
    img: "/img/emagrecimento/conduta-4.webp",
    titulo: "Exames conforme o caso",
    texto: "Os exames são solicitados de acordo com a individualidade de cada paciente, sem pacote pronto. A coleta é feita no laboratório de sua preferência, em Bauru ou na sua cidade.",
  },
  {
    img: "/img/emagrecimento/conduta-5.webp",
    titulo: "Plano e acompanhamento",
    texto: "Com a avaliação completa, construímos um plano individualizado, que pode envolver alimentação, exercício, sono, suplementação e, quando há indicação médica, medicamentos ou tratamento hormonal. O acompanhamento é feito de perto pelo próprio Dr. Thiago, presencialmente em Bauru ou por teleconsulta.",
  },
];

export function NutrologoBauru() {
  return (
    <main className="pag-local">
      <Hero
        trilha={[
          { nome: "Home", href: "/" },
          { nome: "Consultório em Bauru", href: "/bauru/" },
          { nome: "Nutrólogo em Bauru" },
        ]}
        sobretitulo="ATENDIMENTO EM BAURU"
        linha1="Nutrólogo"
        linha2="em Bauru."
        chamada="O Dr. Thiago Viana é médico nutrólogo em Bauru (CRM-SP 144.585, RQE 121770) e atende no Edifício Prime Square, Torre 2, no Jardim Europa. A consulta é particular, inclui bioimpedância e cuida de emagrecimento, massa muscular e saúde metabólica e hormonal. Também há teleconsulta para todo o Brasil."
        imagem="/img/emagrecimento/hero.webp"
        botao="Agendar pelo WhatsApp"
      />

      <SecaoTexto titulo="Endereço, horário e como chegar">
        <Texto
          texto={`- **ITV Instituto Dr. Thiago Viana**
- **Endereço:** Av. Getúlio Vargas, 22-25, Sala 7, Torre 2, Jardim Europa, Bauru-SP, CEP 17017-383
- **Telefone:** (14) 99822-0707
- **E-mail:** consultorio@drthiagoviana.com
- **Horário:** segunda a sexta, das 9h às 18h, com hora marcada
- **Avaliações:** [Ver avaliações no Google](https://maps.google.com/?cid=13509211634599351926)

O Edifício Prime Square fica na Av. Getúlio Vargas, na zona sul de Bauru, perto do cruzamento com a Av. Nossa Senhora de Fátima. São duas torres comerciais, e o consultório fica na Torre 2. O prédio tem garagem com vagas rotativas para visitantes.`}
        />
        <MapaConsultorio />
        <BotaoWhatsApp rotulo="Agendar pelo WhatsApp" />
      </SecaoTexto>

      <Pilares
        sobretitulo="NUTROLOGIA"
        titulo="O que um médico nutrólogo trata"
        chamada="A Nutrologia é uma especialidade médica reconhecida pelo Conselho Federal de Medicina. O nutrólogo é o médico que diagnostica, previne e trata doenças relacionadas à nutrição."
        itens={pilares}
      />

      <SecaoTexto titulo="Nutrólogo, endocrinologista ou nutricionista: qual procurar?" areia>
        <Texto
          texto={`Essa é uma das dúvidas mais comuns de quem busca atendimento em Bauru. As três atuações se complementam, e é comum o mesmo paciente ser acompanhado por mais de um profissional.

| | Formação | O que faz | Quando procurar |
|---|---|---|---|
| **Nutrólogo** | Médico com título de especialista em Nutrologia (RQE) | Investiga e trata doenças ligadas à nutrição, pede exames e pode prescrever tratamento | Dificuldade para emagrecer, perda de massa muscular, deficiências nutricionais, cansaço sem causa clara |
| **Endocrinologista** | Médico com título de especialista em Endocrinologia e Metabologia | Trata doenças das glândulas e dos hormônios, incluindo diabetes, tireoide e obesidade | Diabetes, doenças da tireoide e outras alterações hormonais |
| **Nutricionista** | Graduação em Nutrição, com registro no Conselho Regional de Nutricionistas (CRN) | Monta o plano alimentar e faz a educação alimentar | Organizar a alimentação no dia a dia, com ou sem acompanhamento médico |`}
        />
      </SecaoTexto>

      <CardsIlustrado
        sobretitulo="NO CONSULTÓRIO"
        titulo="Como é a consulta no consultório de Bauru"
        chamada="A primeira consulta é longa e reserva espaço para a sua história. Ela segue estas etapas:"
        cards={etapas}
      />

      <SecaoTexto titulo="O que é tratado no consultório" areia>
        <Texto
          texto={`- **[Médico para emagrecer em Bauru](/medico-para-emagrecer-em-bauru/)**: tratamento do sobrepeso e da obesidade com investigação das causas e cuidado com a massa muscular.
- **[Médico do esporte em Bauru](/medico-do-esporte-em-bauru/)**: avaliação de saúde, composição corporal, nutrição e recuperação para quem treina ou quer começar.
- **[Saúde hormonal](/tratamentos/saude-hormonal/)**: investigação de sintomas e exames antes de qualquer indicação de tratamento hormonal.
- **[Avaliação 360°](/tratamentos/avaliacao-360/)**: a porta de entrada do consultório, com nove frentes avaliadas na mesma consulta.
- **[Massa muscular e sarcopenia](/tratamentos/massa-muscular/)**: para quem está perdendo músculo ou tem dificuldade para ganhar.
- **[Longevidade e qualidade de vida](/tratamentos/longevidade/)**: prevenção com foco em autonomia, massa muscular e saúde metabólica ao longo dos anos.`}
        />
      </SecaoTexto>

      <SecaoTexto titulo="Quem é o Dr. Thiago Viana">
        <Texto
          texto={`O Dr. Thiago Viana é médico formado pela Universidade Federal de São Paulo, Escola Paulista de Medicina (UNIFESP-EPM), em 2010, com registro CRM-SP 144.585. Tem título de especialista em Nutrologia (RQE 121770) e em Medicina do Esporte (RQE 118488), que podem ser conferidos na [busca pública de médicos do CFM](https://portal.cfm.org.br/busca-medicos/).

É membro da Associação Brasileira de Nutrologia (ABRAN), da Sociedade Brasileira de Medicina do Exercício e do Esporte (SBMEE), da Sociedade Brasileira de Medicina da Obesidade (SBEMO), do European Board of Obesity Medicine (EBOM) e do Pan American Board of Obesity Medicine (PABOM). Criou o Método SP, Saúde com Propósito, que organiza o cuidado em pilares como alimentação, exercício, sono, saúde metabólica e hormonal, saúde emocional e propósito. [Conheça a trajetória do Dr. Thiago](/sobre/).`}
        />
      </SecaoTexto>

      <SecaoTexto titulo="Atendimento para quem não mora em Bauru" areia>
        <Texto texto="A teleconsulta atende pacientes de todo o Brasil, com a mesma avaliação de histórico, sintomas, hábitos e exames, que você faz no laboratório da sua cidade. Quando houver necessidade de exame físico ou de uma avaliação específica, indicamos a consulta presencial no consultório do Jardim Europa. Veja como funciona a [teleconsulta](/consulta-online/)." />
      </SecaoTexto>

      <SecaoTexto titulo="Como agendar a consulta em Bauru">
        <Texto texto="Se o peso, a disposição ou a composição corporal estão difíceis de ajustar, o primeiro passo é uma avaliação individualizada que olhe alimentação, sono, exercício e exames juntos. É assim que montamos a [Avaliação 360°](/tratamentos/avaliacao-360/), presencial em Bauru ou por teleconsulta em todo o Brasil. O agendamento é pelo WhatsApp, onde você recebe o valor, as formas de pagamento e os horários disponíveis." />
        <BotaoWhatsApp rotulo="Agendar pelo WhatsApp" />
      </SecaoTexto>

      <Faq titulo="Perguntas frequentes" itens={faqNutrologoBauru} />
      <AutoriaComAviso />
      <CtaPratico linha1="Agende sua consulta com" linha2="nutrólogo em Bauru. Escolha o formato." />
    </main>
  );
}
